// extracted by mini-css-extract-plugin
export default {"login":"Login_login__l7eFe","login-form":"Login_login-form__Wog6d","fade-in":"Login_fade-in__GnajY","dropdown":"Login_dropdown__28nTa"};